import '../../App.less';
import {Spin,Badge, Layout,Tabs, Select,Comment,Avatar, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space,notification,AutoComplete, Card, Checkbox,Popconfirm,Transfer,Tooltip } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import {MinusOutlined,CheckOutlined,StarOutlined,PlusOutlined, MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined, LikeOutlined,DislikeOutlined, SearchOutlined,CalendarOutlined,EditOutlined, UnorderedListOutlined,TagsOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined,BarChartOutlined } from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import {getAuthors,getAuthorsStr, getCountryName,IP,getCountryCode, countDownNotification, getPon, getPonStr} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
import ClosedEnvelope from '@iconscout/react-unicons/icons/uil-envelope-times'
import OpenedEnvelope from '@iconscout/react-unicons/icons/uil-envelope-check'

class Playslist extends Component {
  constructor(props){
    super(props)
    this.state={
      plays:[],
      showArticle:false,
      record:null,
      recordAuthor:null,
      edit:false,
      categoryChanged:"",
      conc:[],
      filteredInfo:[],
      makeGenreReport:false,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false,
      selectedRows:[],
      qualifiedChanged:false,
      qualifiedChangedValue:undefined,
      preselectedChanged:false,
      preselectedChangedValue:undefined,
      showCommentSection:false,
      comment:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      comment_answer_text:undefined,
      jurys_dict:{},
      juryId:undefined,
      logued:false,
      reportByAuthor:true,
      isBusy:false,
      showAuthor:false,
      showAddPonencias:false,
      unassignedPlays:[],
      assignedPlays:[],
      allPlays:[],
      saveAddPlays:false,
      showAddPanel:false,
      newPanelTitle:""
    }
  }
  isArrayInArray(arr, item){
    var item_as_string = JSON.stringify(item);
    var contains = arr.some(function(ele){
      return JSON.stringify(ele) === item_as_string;
    });
    return contains;
  }
  async componentDidMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/culturasOriginarias/panel/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    this.countries = new Set();
    this.ponencias = []
    
    var poesia = []
    var ensayo = []
    var novela = []
    const Moment = require('moment');
   
    const json_pon = [].concat.apply([],json_plays.map(play=> {return play.ponencias})) 
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var pon= getPon(item.ponencias)
      var p= getPonStr(item.ponencias)
      for(var j in p ){
        this.authorsStr.add(p[j])
      }
      
      for(var j=0;j<item.ponencias.length;j++){
        let tuple = [item.ponencias[j].id.toString(),item.id.toString()]
        this.ponencias.push(tuple)
      }
      const year = date.split('-')[2]
      
      this.codes.add(year+'_'+item.genero+'_'+item.id);
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      data.push(
          { 
              key : item.id.toString(),
              id : item.id,
              title : item.titulo,
              ponencias: pon ,
              code:year+'_'+item.id,
              edit:'',
              qualified:item.califica,
              date:date,
              email_sended:item.ponencias.some(p=>p.correo_enviado),
              manual: item.creado_manualmente

          });
    };
    var data_conc = []

    this.names = new Set();
    this.emails = new Set();
    
    for(var i in json_pon){


      var item = json_pon[i];
      console.log("UUUU",i,item)
      
      this.names.add(item.titulo )
      data_conc.push(
          { 
            key : item.id.toString(),
            title:item.titulo,
              id : item.id,
              name : item.titulo,
              
          });
    };
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({ plays: data , conc:data_conc, filteredInfo:data_conc,logued:true});
    console.log("FILTERED",data_conc)
    console.log()
   
  }
  
  async getPlays(){//loads all plays and its details
    const Moment = require('moment');
    var data = []
    this.setState({isBusy:true})
    const response = await fetch(IP + 'api/culturasOriginarias/panel/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    for(var i in json){
      var item = json[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      
      const year = date.split('-')[2]
      var pon= getPon(item.ponencias)
      var p= getPonStr(item.ponencias)
      data.push(
          { 
            key : item.id.toString(),
              id : item.id,
              title : item.titulo,
              ponencias: pon ,
              code:year+'_'+item.id,
              edit:'',
              qualified:item.califica,
              date:date,
              email_sended:item.califica && item.ponencias.some(p=>p.correo_enviado),
          });
    };
    this.setState({ plays: data,isBusy:false})
  }

  async changeQualification(id,value,preselectedValue){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    
    var playChanged={
      "califica":value,
  }
    await axios.patch(IP + `api/culturasOriginarias/panel/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
          var userId = localStorage.getItem("UserId")
          this.getPlays()
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }
  async sendEmail(id){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    
    var playChanged={
      "enviar":true,
  }
    await axios.patch(IP + `api/culturasOriginarias/panel/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
          var userId = localStorage.getItem("UserId")
          this.getPlays()
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }
  async changePreselection(id,value){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
   
    var playChanged= value == true ? {"preseleccionada":value,"califica":true}:{"preseleccionada":value}
    await axios.patch(IP + `api/culturasOriginarias/panel/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
         var userId = localStorage.getItem("UserId")
          
           const data_log= new FormData()
           data_log.append('usuario',userId)
           data_log.append('accion',value ==null ?"Estado de obra cambiado a sin determinar preselección" : value ?"Estado de obra cambiado a preseleccionada":"Estado de obra cambiado a no preseleccionada")
           data_log.append('obra',id)
           axios.post(IP + 'api/casa/logs/', data_log).then((val)=>this.getPlays())
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }

  async qualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = true
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/panel/`, options)
    .then(
      async(response) => {
        if(response.status === 200 || response.status === 201){
          var data={}
          data['ids'] =  this.state.selectedRows
          var userId = localStorage.getItem("UserId")

          data['usuario'] = userId
          data['accion'] = "Estado de obra cambiado a calificada"
          
          var options = {
              method: "post",
              credentials: "same-origin",
              headers: {
                "Authorization": localStorage.getItem("Authorization") ,
                "Accept": "application/json",
                "Content-Type": "application/json"},
              body:JSON.stringify(data)
            }
          fetch(IP + `api/casa/logs/`, options).then(response=> this.getPlays())
        }
      },
      (error) => {
        this.setState({isBusy:false})
        countDownNotification(notification.error,'Error','Por favor intente más tarde','error');
      }
    ).catch((err) => countDownNotification(notification.error,'Error','Por favor intente más tarde','error'))
  }
  async undefinedQualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = "undefined"
    data['preseleccionada'] = "undefined"
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/panel/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async unqualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = false
    data['preseleccionada'] = false
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/panel/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
      }
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async undefinedPreselectAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = false
    data['preseleccionada'] = undefined
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/panel/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  
  onNewPanel =()=>{
      const data= new FormData()
         
      data.append('tituloPanel',document.getElementById("inputTitleNew").value)
    data.append('premio',3)
    this.setState({isBusy:true},()=>axios.post(IP + 'api/culturasOriginarias/register/panel', data).then((res) => {
      if (res.status == 200){
        this.setState({isBusy:false})
        Modal.success({
          content: 'Panel creado correctamente',
          onOk:()=> window.open("/culturasOriginarias/admin_pan","_self")
        });
      } ;
    }).catch((err) => {
        this.setState({isBusy:false})
        notification.error({
          message:'Error',
          description:err.response,
        });
      }))

  }
  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };
  onchangeTab(tab){
    var plays = []
    if(tab=="1"){//all plays
      plays = this.state.plays
    }
    if(tab=="2"){//qualified
      plays = this.state.plays.filter(p=>p.qualified)
    }
    if(tab=="3"){//not qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)
    }
    if(tab=="4"){//not analyzed to be qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined)
    }
    
   
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    plays.forEach(play =>{
      var a= getAuthorsStr(play.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      this.auths.add(play.author)
      this.titles.add(play.title)
      this.dates.add(play.date)
    })
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({selectedRows:[]})
  }

 
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};

  onClickEditPlay(record){
    console.log("RECORD",record)

    var assigned = record.ponencias.map(p=>p.id.toString())
    const ids = this.ponencias.map(h=>h[0].toString())
    console.log("Assigned",assigned)
    console.log("ids",ids)

    var unassigned = this.state.filteredInfo.filter(p=>(!assigned.includes(p.key)))
    console.log("unassigned",unassigned)
    console.log("filteredInfo",this.state.filteredInfo)
    this.setState({edit:true,record:record,unassignedPlays:[...unassigned], assignedPlays:[...assigned], newJuryCategory:record.category});
        
  };
  onChangeSelect(value){
    this.setState({categoryChanged:value})
  }
  

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }
  onChangeSelectedRows(rows){
    this.setState({selectedRows:rows})
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "category"){
      return this.categories
    }
    
    else{
      return this.dates
    }
  }
  handleTransferChange = (newTargetKeys, direction, moveKeys) => {
    direction=='left'? this.setState({ assignedPlays:[...newTargetKeys] }): this.setState({ assignedPlays:this.state.assignedPlays.concat(moveKeys) })
  };
async onClickSave(){

  var options = {
     method: "patch",
     credentials: "same-origin",
     headers: {
       "Authorization": localStorage.getItem("Authorization") ,
       "Accept": "application/json",
       "Content-Type": "application/json"},
     proxy: {
       host: 'localhost:8000',
       port: 8000
     }
   }
   
   var playChanged={}
   var preselectedValue = this.state.preselectedChanged?this.state.preselectedChangedValue:this.state.record.preselected
   var qualifiedValue = this.state.qualifiedChanged?this.state.qualifiedChangedValue:this.state.record.qualified
     playChanged={
       titulo: document.getElementById("inputTitle").value,
       califica:preselectedValue ? true : qualifiedValue,
       ponencias:this.state.saveAddPlays? this.state.assignedPlays.map(p=> parseInt(p)): this.state.record.ponencias.map(p=> p.id)
     }
   await axios.patch(IP + `api/culturasOriginarias/panel/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       if(response.status === 200){
        var userId = localStorage.getItem("UserId")
        if(this.state.preselectedChanged){
          // const data_log= new FormData()
          // data_log.append('usuario',userId)
          // data_log.append('accion',preselectedValue ? "Estado de obra cambiado a preseleccionada":"Estado de obra cambiado a no preseleccionada")
          // data_log.append('obra',this.state.record.id)
          // axios.post(IP + 'api/casa/logs/', data_log)
        }

        // if(this.state.qualifiedChanged){
        //   // const data_log= new FormData()
        //   // data_log.append('usuario',userId)
        //   // data_log.append('accion',qualifiedValue ? "Estado de obra cambiado a calificada":"Estado de obra cambiado a descalificada")
        //   // data_log.append('obra',this.state.record.id)
        //   // axios.post(IP + 'api/casa/logs/', data_log)
        // }
         window.location.reload();
       }
        
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
     },
     (error) => {
      notification.error({
        message:'Error',
        description:'Hubo un error, por favor revise los datos',
      });
     }
   ).catch((err) => notification.error({
    message:'Error',
    description:'Hubo un error, por favor revise los datos',
  }))
   this.setState({qualifiedChanged:false,preselectedChanged:false,categoryChanged:""})
 }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a style={{color:record.manual ? 'orange':'blue'}} onClick = {()=>this.setState({showAuthor:true,record:record,recordAuthor:a.id})} >{a.name}</a> </li>})}</ol> )
              || (<a style={{color:record.manual ? 'orange':'blue'}}  onClick = {()=>this.onClickArticle(record)} >  {text}</a> )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
      
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

  render() {
    /////Authors////
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays,"read")

    const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays,"save",true)
    const readPlayReportGenre =()=> generatePDFPlay(this.state.plays,"read",true)

    const downloadCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

    const downloadPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"save")
    const readPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"read")
    /////////Pseudo/////
    const downloadPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"save",false,false,'',false)
    const readPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"read",false,false,'',false)

    const downloadPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"save",true,false,'',false)
    const readPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"read",true,false,'',false)

    const downloadCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"save",false,false,'',false)
    const readCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"read",false,false,'',false)

    const downloadPlayReportSelectedCountryPseudo=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,false)
    const readPlayReportSelectedCountryPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,false)

    const downloadPlayReportGenreSPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenreSPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"read",false,false,'',false)

    ///Conc////
    const downloadConcReport =()=> generatePDFConc(this.state.conc,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc,"read")
    ////


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
      const {  Content } = Layout;
      const columns = [
                
                  
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    sorter: (a, b) => a.title.localeCompare(b.title),
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] ,
                   
                  },
                
                 
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
                    dataIndex: 'date',
                    key: 'date',
                    width:'8%',
                    sorter:(a,b) => moment.utc(a.unixDate).diff(moment.utc(b.unixDate)),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('date','fecha'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Calificada</div>,
                    dataIndex: 'qualified',
                    key: 'qualified',
                    width:'100px',
                    render: (text,record) =>(
                      <Row  align="middle" justify="center"  >
                        <Col >
                            {record.qualified != undefined ? (record.qualified ? <a onClick={()=>this.changeQualification(record.id,null)}><LikeOutlined  style={{color:'green'}} /></a>:<a onClick={()=>this.changeQualification(record.id,true)}> <DislikeOutlined  /></a>): <a onClick={()=>this.changeQualification(record.id,false)}> <MinusOutlined /></a>}
                        </Col>
                      </Row>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] ,
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Correo enviado</div>,
                    dataIndex: 'qualified',
                    key: 'qualified',
                    width:'100px',
                    render: (text,record) =>(
                      <Row  align="middle" justify="center"  >
                        <Col >
                            {record.email_sended != undefined ? (record.email_sended ? <OpenedEnvelope  style={{color:'green'}} />:<Popconfirm
                              title="Está seguro que desea enviar el correo a todos los autores pertenecienetes al panel?"
                              description=" Se enviará el correo a todos los autores pertenecienetes al panel"
                              onConfirm={()=>this.sendEmail(record.id)}
                              // onCancel={cancel}
                              okText="Sí"
                              cancelText="No"
                              disabled = {!record.qualified}
                            ><a disabled = {!record.qualified}><ClosedEnvelope style={{color:'red'}} /></a></Popconfirm>): <ClosedEnvelope style={{color:'red'}}/>}
                        </Col>
                      </Row>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] ,
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
              
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'5%',
                    render: (text,record) =>(
                      <div  style={{fontSize:'large' }}>
                      <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                      </div>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                    
                  },
            ];

    const url = this.state.record?.pdf
    const downloadUrl = IP + 'api/casa/file/'+ this.state.record?.id

    const readFile =  ()=>{
      window.open(url)
    };
    const downloadFile=()=>{
      fetch(downloadUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
        }
      })
        .then(res => res.blob())
        .then(response => {
          //Create a Blob from the PDF Stream
          const blob = new Blob([response], {
            type: "application/pdf"
          });
          //Build a URL from the file
          // const fileURL = URL.createObjectURL(file);

          const link = document.createElement('a');
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = this.state.record.code;
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          setTimeout(() => URL.revokeObjectURL(link.href), 7000);
          //Open the URL on new Window
          // window.open(fileURL);
        })
        .catch(error => {
          console.log(error);
        });
    }
    

    const closeComments=()=>{
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined})
    }
    const { SubMenu } = Menu;
    const { Option } = Select;
    const { TabPane } = Tabs;
    const { TextArea } = Input;
    const reportMenu = (
      <SubMenu disabled={!this.state.logued} key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
        <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
          <SubMenu  key="playAuth" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con autores</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Agrupadas por género</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportGenre}>Ver</Button> <Button onClick={downloadPlayReportGenrePseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            
            <Menu.Item>
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
          <SubMenu  key="playPseudo" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con seudónimo</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportPseudo}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Agrupadas por género</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportGenrePseudo}>Ver</Button> <Button onClick={downloadPlayReportGenre}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReportPseudo}>Ver</Button> <Button onClick={downloadCurrentReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Item>
                <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
        </SubMenu>
      <SubMenu  key="rep_conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
          <Menu.Item>
            <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
  </SubMenu>
    )
    return (
      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
               <AdminMenu defaultSelectedKey={"plays"} reportMenu={reportMenu} />
            <Spin spinning={this.state.isBusy || !this.state.logued} >
            <Content>
           
              <Tabs  type="card" defaultActiveKey="1" onChange={(key)=>this.onchangeTab(key)} >
                <TabPane tab="Todos los Paneles" key="1">
                  <Card>
                    {this.state.selectedRows.length > 0 && 
                    <Row gutter={10}>
                      <Col>
                        <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.undefinedQualifyAll()}>Sin determinar calificación</Button>
                      </Col>
                      <Col>
                      </Col>
                    </Row>}
                <div style={{ marginBottom: 16}}>
                  <Row>
                  
                <Col span={24}>
                <ul className="toolbar" style={{ float: 'left' }}>
            <li><Tooltip placement="topLeft" title="Añadir Panel"><Button icon={<PlusOutlined />} onClick={()=>this.setState({showAddPanel:true})}></Button></Tooltip></li>
            </ul>
            </Col>
            </Row>
</div>
            <Row>
                <Col span={24}>
                  <Table
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                    }}
                    columns={columns}
                    dataSource= {this.state.plays}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Calificadas" key="2">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? [] : this.state.plays.filter(p=>p.qualified).map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                
                    }}
                    columns={columns}
                    dataSource= {this.state.plays.filter(p=>p.qualified)}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Descalificadas" key="3">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                <TabPane tab="Sin determinar calificación" key="4">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                
           
                
              </Tabs>
              {
                    this.state.showArticle && 
                    <Modal 
                        closable = {false}
                        title={ this.state.record.code}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                          
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                             
                        ]}
                    >

                         <p><FileTextOutlined />Título: {this.state.record.title}</p>
                        
                        <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                        <p>
                          <CheckOutlined />Calificada: {this.state.record.qualified == undefined ? "Sin Determinar":(this.state.record.qualified ? "Calificada":"Descalificada" )  }
                          </p>

                          {this.state.record.ponencias.map((a,idx)=>{return <p><UnorderedListOutlined />Ponencia {idx + 1 }: {a.title} </p>})}
                    </Modal>
                    || (this.state.edit && 
                      <Modal 
                          closable = {false}
                          title={ this.state.record.code}
                          visible={this.state.edit} 
                          onCancel={this.hideEdit}
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                           <p><FileTextOutlined />Título: <Input style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" /></p>
                          
                          <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
  
                          
                          <p>
                          <CheckOutlined />Calificada: 
                            <Select defaultValue={this.state.record.qualified } style={{marginLeft:5}} onChange={(value)=>this.setState({qualifiedChangedValue:value, qualifiedChanged:true})}>
                              <Option value={true}>Calificada</Option>
                              <Option value={false}>Descalificada</Option>
                              <Option value={undefined}>Sin Determinar</Option>
                            </Select>  
                          </p>
                         {this.state.record.ponencias.map((a,idx)=>{return <p><UnorderedListOutlined />Ponencia {idx + 1 }: {a.title} </p>})}

                          <p>
                            
                            <Button onClick={()=>this.setState({showAddPonencias:true})}>Asignar Ponencias</Button>
                            
                          </p>
  
                      </Modal>)
                      }
                        {this.state.makeGenreReport &&
              <Modal
              closable = {false}
              title="Reporte por género"
              visible={this.state.makeGenreReport}
              footer={[
                <Button key="back" onClick={onClosekGenreReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportGenre}
                   onChange={onChangeReportGenre}
                   >
                    {this.categories.map(element => {return <Option value={Object.entries(element)[0][1]}>{Object.entries(element)[0][1]}</Option>})}
                  </Select>
                  <div>
                    <br/>
                  <Button onClick={this.state.reportByAuthor ? readPlayReportGenreS:readPlayReportGenreSPseudo }>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportGenreS:downloadPlayReportGenreSPseudo }>Descargar</Button>

                  </div>
               

              </Modal>}

              {this.state.makeCountryReport &&
              <Modal
              closable = {false}
              title="Reporte por país"
              visible={this.state.makeCountryReport}
              footer={[
                <Button key="back" onClick={onClosekCountryReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportCountry}
                   onChange={onChangeReportCountry}
                   >
                    {[...this.countries].map(c => {return <Option value={c}>{c}</Option>})}
                  </Select>
                  <div>
                    <br/>
                    <Button onClick={this.state.reportByAuthor ? readPlayReportSelectedCountry : readPlayReportSelectedCountryPseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportSelectedCountry:downloadPlayReportSelectedCountryPseudo}>Descargar</Button>
                  </div>
              </Modal>}
              { this.state.showCommentSection && <Modal 
                          closable = {false}
                          title={ "Comentarios"}
                          visible={this.state.showCommentSection} 
                          width={580}
                          footer={[
                           
                              <Button key="backComment" onClick={closeComments}>
                              Cerrar
                              </Button>,
                               
                          ]}
                          >
                         <Row align="middle" justify="center" >
                           <Col span={24}>
                           <Comment
                              actions={[<Button type="primary" disabled={this.state.edit_comment || !this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} onClick={()=>this.postComment(this.state.record.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                              avatar={
                                  <Avatar
                                    src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.juryId].nombre_completo}&background=random`}
                                    alt={this.state.jurys_dict[this.state.juryId].nombre_completo}
                                  />
                              }
                              content={
                                <TextArea disabled={this.state.edit_comment} placeholder={"Añadir comentario"} value={!this.state.edit_comment && this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                              }
                            />
                            {
                              Object.entries(this.state.comment).map(element=>{
                                if (!element[1].comentario_padre){
                                  return this.getChildComments(element[1])
                                }
                              })
                              
                            }
                           </Col>
                         </Row>
                      </Modal>}
                      {
                    this.state.showAuthor && 
                    <Modal 
                    closable = {false}
                        title={"Detalles de autor"}
                        visible={this.state.showAuthor} 
                        onCancel={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}
                        footer={[
                            <Button key="back" onClick={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        {/* <p><UserOutlined /> Nombre: {this.state.record.conc[this.state.recordAuthor].nombre_completo}</p> */}
                        <p><MailOutlined /> Email: {this.state.record.conc[this.state.recordAuthor].email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.conc[this.state.recordAuthor].telefono}</p>
                        <p><GlobalOutlined /> País: { getCountryName(this.state.record.conc[this.state.recordAuthor].pais)}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.conc[this.state.recordAuthor].direcc_personal}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.conc[this.state.recordAuthor].ficha}</p>
                    </Modal>
                    }

{ this.state.showAddPonencias && 
                    <Modal 
                      closable = {false}
                      title={ "Administara ponencias del panel"}
                      visible={this.state.showAddPonencias} 
                      width={1080}
                      footer={[
                        <Button key="save" onClick={()=>this.setState({showAddPonencias:false,saveAddPlays:true})}>
                          Guardar
                        </Button>,
                        <Button key="back" onClick={()=>this.setState({showAddPonencias:false,saveAddPlays:false})}>
                          Cancelar
                        </Button>,
                        ]}>
                      <Row align="middle" justify="center" >
                        <Col span={24}>
                          <Transfer 
                            onChange={this.handleTransferChange}
                            dataSource={ this.state.unassignedPlays}
                            targetKeys={this.state.assignedPlays}
                            listStyle={{ width: 500,height: 300}}
                            render={item => {return item.name}}
                            titles={['Sin asignar', 'Asignadas']}
                          />
                        </Col>
                      </Row>
                    </Modal>}

{this.state.showAddPanel && 
                      <Modal 
                          closable = {false}
                          title={ "Añadir nuevo panel"}
                          visible={this.state.showAddPanel} 
                          onCancel={()=>this.setState({showAddPanel:false,newPanelTitle:""})}
                          footer={[
                            <Button key="save" onClick={()=>this.onNewPanel()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={()=>this.setState({showAddPanel:false,newPanelTitle:""})}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                            <p><FileTextOutlined />Título: <Input style={{width:'80%'}} id ="inputTitleNew"   onChange={(val)=> this.setState({newPanelTitle:val})}/></p>
                         
                      </Modal>
                      }
                    
            </Content>
            </Spin>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>

    );
  }
}
export default Playslist;


